export const POS_CREATE_REQUESTED = 'POS_CREATE_REQUESTED';
export const POS_CREATE_SUCCEED = 'POS_CREATE_SUCCEED';
export const POS_CREATE_FAILED = 'POS_CREATE_FAILED';

export const POS_GET_REQUESTED = 'POS_GET_REQUESTED';
export const POS_GET_SUCCEED = 'POS_GET_SUCCEED';
export const POS_GET_FAILED = 'POS_GET_FAILED';
